import { createContext, useContext, useMemo, useState } from 'react';
import { useDidUpdate } from '../hooks/useDidUpdate';
import { useMediaQuery } from '../hooks/useMediaQuery';

export type ScreenList = 'mobile' | 'tablet' | 'interim' | 'laptop' | 'desktop';
export interface UseScreenSizesReturn {
    current: ScreenList;
    mobile?: boolean;
    tablet?: boolean;
    interim?: boolean;
    laptop?: boolean;
    desktop?: boolean;
}

export interface ScreenSizesContext extends UseScreenSizesReturn {}

export interface ScreenSizesProviderProps {
    children: React.ReactNode;
}

const ScreenSizesContext = createContext({} as ScreenSizesContext);
export const useScreenSizes = () => useContext(ScreenSizesContext);
export const ScreenSizesProvider = (props: ScreenSizesProviderProps) => {
    const mobile = useMediaQuery('(max-width: 639px)');
    const tablet = useMediaQuery('(min-width: 639px) and (max-width: 1023px)');
    const interim = useMediaQuery('(min-width: 1023px) and (max-width: 1270px)');
    const laptop = useMediaQuery('(min-width: 1023px) and (max-width: 1359px)');
    const desktop = useMediaQuery('(min-width: 1359px)');
    // const desktop = useMediaQuery('(min-width: 1360px)');

    const current = tablet || mobile ? 'mobile' : laptop || desktop ? 'desktop' : undefined;
    const [currentScreen, setCurrentScreen] = useState<ScreenList>(current as ScreenList);

    useDidUpdate(() => {
        if (current !== undefined && current !== currentScreen) {
            setCurrentScreen(current);
        }
    }, [current]);

    const value = useMemo<ScreenSizesContext>(() => {
        return {
            current: currentScreen,
            mobile: tablet || mobile,
            tablet,
            interim,
            laptop,
            desktop: laptop || desktop
        };
    }, [mobile, tablet, interim, laptop, desktop, currentScreen]);

    return <ScreenSizesContext.Provider value={value}>{props.children}</ScreenSizesContext.Provider>;
};
